/* eslint-disable @typescript-eslint/no-explicit-any */
import axios, { AxiosInstance } from 'axios';

const baseURL = process.env.REACT_APP_API_URL;

const axiosInstance: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});
const axiosInstance3: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});
const axiosInstance2: AxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
export const addAuthInterceptor = (instance: AxiosInstance, keycloak: any) => {
  instance.interceptors.request.use(
    async (config) => {
      if (keycloak.authenticated && keycloak.token) {
        try {
          await keycloak.updateToken(30);
        } catch (error) {
          console.error('Failed to refresh token', error);
        }

        config.headers.Authorization = `Bearer ${keycloak.token}`;
      }

      return config;
    },
    (error) => Promise.reject(error),
  );
};

export { axiosInstance, axiosInstance2, axiosInstance3 };
